import { useEffect, useState } from "react";
import { Badge, Popover } from "antd";
import { AlertOutlined, BellOutlined, FieldTimeOutlined, UserOutlined } from "@ant-design/icons";

import SessionService from "../../../../services/session/SessionService";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import TaskList from "./component/task-list/TaskList";
import Account from "./component/account/Account";
import AlarmEventList from "./component/alarm-event-list/AlarmEventList";
import { LeftWrapper, MainStatusBarWrapper, NotifyButton, RightWrapper, ViewTitle } from "./MainStatusBar.styled";

interface MainStatusBarProps {

}

const MainStatusBar: React.FC<MainStatusBarProps> = (props)=> {
    // api
    let viewStateService = ViewStateService.getInstance();

    // current user profile
    let currentUserProfile = SessionService.getInstance().getCurrentUserProfile();

    // current title
    let [title, setTitle] = useState(viewStateService.getStatusBarTitle());
    let [openTaskList, setOpenTaskList] = useState(false);
    let [openAlarmEventList, setOpenAlarmEventList] = useState(false);
    let [unackedAlarmEventCount, setUnackedAlarmEventCount] = useState(0);

    // effect
    useEffect(()=> {
        // load
        let statusBarTitleChangeListener = (statusBarTitle)=> {
            setTitle(statusBarTitle);
        };
        viewStateService.addStatusBarTitleChnageListener(statusBarTitleChangeListener);

        let taskNotificationListener = ()=> {
            setOpenTaskList(true);
        };
        viewStateService.addNewTaskListener(taskNotificationListener);

        let unackAlarmEventsListener = (alarmEventViews)=> {
            setUnackedAlarmEventCount(alarmEventViews.length);
        };
        viewStateService.addAlarmEventsListener(unackAlarmEventsListener);

        // unload
        return ()=> {
            viewStateService.removeStatusBarTitleChnageListener(statusBarTitleChangeListener);
            viewStateService.removeNewTaskListener(taskNotificationListener);
            viewStateService.removeAlarmEventsListener(unackAlarmEventsListener);
        }
    }, []);

    return (
        <MainStatusBarWrapper>
            <LeftWrapper>
                <ViewTitle>{title}</ViewTitle>
            </LeftWrapper>
            <RightWrapper>
                <Popover placement="bottom" content={<AlarmEventList />} trigger="click" open={openAlarmEventList} onOpenChange={(open)=> setOpenAlarmEventList(open)}>
                    <NotifyButton onClick={()=> setOpenAlarmEventList(true)}>
                        <Badge count={unackedAlarmEventCount}>
                            <AlertOutlined style={{fontSize: '18px'}} />
                        </Badge>
                    </NotifyButton>
                </Popover>

                <NotifyButton>
                    <BellOutlined />
                </NotifyButton>

                <Popover placement="bottom" content={<TaskList />} trigger="click" open={openTaskList} onOpenChange={(open)=> setOpenTaskList(open)}>
                    <NotifyButton onClick={()=> setOpenTaskList(true)}>
                        <FieldTimeOutlined />
                    </NotifyButton>
                </Popover>

                <Popover placement="bottom" title="" content={<Account />} trigger="click">
                    <NotifyButton>
                        <UserOutlined />
                    </NotifyButton>
                </Popover>
            </RightWrapper>
        </MainStatusBarWrapper>
    )
}

export default MainStatusBar;

